import cn from 'classnames';

import { Counter } from '../Counter';

const urgencyCounters = [
  { key: 'Urgent', bgColor: 'bg-redColor' },
  { key: 'Important', bgColor: 'bg-orangeColor' },
  { key: 'All', bgColor: 'bg-gray-500' },
];

export const TabLink = ({
  tab,
  counters = {},
  handleCounterClick = () => {},
  handleTabClick = () => {},
  activeButton = false,
  activeUrgency = null,
}) => {
  const { title, value } = tab;
  const isActive = Number(activeButton) === Number(value);

  return (
    <div
      onClick={() => handleTabClick(value)}
      className={cn(
        'relative inline-flex justify-items-center py-2 px-3 rounded-lg border border-gray-200 hover:bg-gray-100 transition cursor-pointer',
        { 'bg-gray-100': isActive }
      )}
    >
      <div className="absolute top-[-16px] right-0 inline-block rounded min-w-[20px] h-[18px] leading-[18px] text-xs whitespace-nowrap text-center overflow-hidden">
        {urgencyCounters.map(({ key, bgColor }) => (
          <Counter
            key={key}
            amount={counters[key] || 0}
            bgColor={cn(bgColor, {
              underline: isActive && activeUrgency === key,
            })}
            onClick={e => {
              e.stopPropagation();
              handleCounterClick(value, key);
            }}
          />
        ))}
      </div>
      <span className="text-sm text-blackColor font-medium">{title}</span>
    </div>
  );
};
